import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { addLocalePrefix } from '/@/utils/router';

const LocalePrefix = ({ language, children }) => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const activeLanguage = language;

        let cleanPathname = location.pathname;

        const splittedPathname = cleanPathname.split('/');
        if (splittedPathname?.[1]?.length === 2) {
            cleanPathname = splittedPathname.slice(2).join('/');
        }

        const redirectTo = addLocalePrefix(activeLanguage, cleanPathname);
        if (redirectTo !== location.pathname) {
            navigate(redirectTo + location.search + location.hash, { replace: true });
        }
    }, [language, location.hash, location.pathname, location.search, navigate]);

    return children;
};

export default LocalePrefix;
